import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsModule } from 'src/app/main/shared/constants/constants.module';
import { HttperrorhandlerService } from 'src/app/main/shared/http/httperrorhandler.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  serviceURL = 'http://40.118.204.142/tomcat/geoserver/NEWRM/ows';
  gisStoreName = 'NEWRM';

  constructor(
    private http: HttpClient,
    private errorHandler: HttperrorhandlerService,
    private constants: ConstantsModule
  ) { }

  getSourceListForComponent(options): Observable<any> {
    return this.http.post<any>(environment.url.PLAY_URL + 'comm/getrankwisesource', options).pipe(
      catchError(this.errorHandler.handleError('All Sources data for Components : ', []))
    );
  }

  getDateRangeForComponent(component: string, source: string): Observable<any> {
    return this.http.get<any>(environment.url.PLAY_URL + 'comm/range2/' + component + '/' + source).pipe(
      catchError(this.errorHandler.handleError('Date range request for ' + component, []))
    );
  }

  getHeirarchy(options: object): Observable<any> {
    const heatMapUrl = 'locations/heirarchy';
    return this.http.post<any>(environment.url.PLAY_URL + heatMapUrl, options).pipe(
      catchError(this.errorHandler.handleError('Rainfall linechart data request', []))
    );
  }

  getLocationLevelForSourceAndComponent(options: object): Observable<any> {
    return this.http.post<any>(environment.url.PLAY_URL + 'comm/getLocTypes', options).pipe(
      catchError(this.errorHandler.handleError('Locations Level for Source Data request', []))
    );
  }

  getHeatMapData(url, options: object): Observable<any> {
    const heatMapUrl = url;
    return this.http.post<any>(environment.url.OBSERVED_API_URL + heatMapUrl, options).pipe(
      catchError(this.errorHandler.handleError('error in Heatmap data request', []))
    );
  }

  getGeoJsonLayerData(layerName: string, filter): Observable<any> {
    let layerURL = this.serviceURL + '?service=WFS&version=1.0.0&request=GetFeature&typeName=' + this.gisStoreName + ':' + layerName + '&maxFeatures=5000000&outputFormat=application%2Fjson' as string;
    if (filter || filter == '') {
      layerURL += '&cql_filter=' + filter;
    }
    return this.http.get(layerURL).pipe(
      catchError(this.errorHandler.handleError('error in GeoJson data request', []))
    );
  }

  getdataGis(url, options: object): Observable<any> {
    return this.http.post<any>(environment.url.PLAY_URL + url, options).pipe(
      catchError(this.errorHandler.handleError('table data request', []))
    );
  }

  formatdata(layer, geodata, data) {
    const component = layer.Component;
    let formatedData;
    if (component == this.constants.COMPONENT.RAINFALL) {
      formatedData = this.formatRFData(geodata, data);
    }
    return formatedData;
  }

  formatRFData(geodata, data) {
    geodata['features'].forEach(station => {
      data.forEach(element => {
        if (station['properties']['loc_uuid'] == element['uuid']) {
          Object.assign(station['properties'], { actual: element['actual'] });
        }
      });
    });
    return geodata;
  }

  getImageBounds(imageBounds) {
    const anchors = [];
    anchors.push([imageBounds[1][0], imageBounds[0][1]]);
    anchors.push([imageBounds[1][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[1][1]]);
    anchors.push([imageBounds[0][0], imageBounds[0][1]]);
    return anchors;
  }

  getHeatMapImageBounds(heatmapimageBounds: any) {
    let latlongs: any = [];
    let imageBounds: any = []

    latlongs.push(heatmapimageBounds['southWest']['latitude']);
    latlongs.push(heatmapimageBounds['southWest']['longitude']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(heatmapimageBounds['northEast']['latitude']);
    latlongs.push(heatmapimageBounds['northEast']['longitude']);
    imageBounds.push(latlongs);
    return imageBounds;
  }

  setMapData(data) {
    let obj = {};
    let imageUrl = {};
    let imageBounds = [];
    let latlongs = [];
    latlongs.push(data['southWest']['latitude']);
    latlongs.push(data['southWest']['longitude']);
    imageBounds.push(latlongs);
    latlongs = [];
    latlongs.push(data['northEast']['latitude']);
    latlongs.push(data['northEast']['longitude']);
    imageBounds.push(latlongs);
    obj['bounds'] = imageBounds;
    return obj;
  }
}
